const firebaseConfig = {
  apiKey: "AIzaSyBbxa7a9QVjMdDjJmEQDniVBq2HJE-oE9g",
  authDomain: "jc-transport.firebaseapp.com",
  projectId: "jc-transport",
  storageBucket: "jc-transport.appspot.com",
  messagingSenderId: "200489680132",
  appId: "1:200489680132:web:21172a6572a4f21183e451",
};
export default firebaseConfig;
